import { store } from '../../store';

export const mockDbName = process.env.VUE_APP_MOCK_DB_NAME;
/** main.ts Decorator */
export default () => {
  console.log('main.ts init with mock data from ' + mockDbName);
  const user = require(`../../../database/${mockDbName}/collections/users.json`)[0];
  store.commit('usersModule/setCurrentUser', user);
}
